var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSendArrow = function SvgSendArrow(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 17,
    viewBox: "0 0 10 17",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.9312 0.333742L9.13413 7.61133C9.53993 8.02073 9.53993 8.70419 9.13413 9.11527L1.9312 16.3912C1.48945 16.8376 0.792087 16.8376 0.350341 16.3912C-0.116967 15.9187 -0.116967 15.1319 0.350341 14.6586L6.383 8.5638C6.49244 8.45367 6.49244 8.27125 6.383 8.16112L0.350341 2.06634C-0.116967 1.59389 -0.116967 0.807033 0.350341 0.333742C0.571613 0.111808 0.855991 0 1.14037 0C1.42555 0 1.70993 0.111808 1.9312 0.333742Z",
    fill: "#007AFF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSendArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/send-arrow.ed38e8ce.svg";
export { ForwardRef as ReactComponent };